// extracted by mini-css-extract-plugin
export default {"title":"discard_title__UkEyy","wrapper":"discard_wrapper__cHyHm","textArea":"discard_textArea__ggIBk"};